<template>
  <div>
    <van-sticky>
      <van-nav-bar
        :title=" title+'('+(this.countStu==-1?this.students.length:this.countStu)+(this.team?'队':'人')+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />

      <van-search
        v-model="searchValue"
        show-action
        :placeholder="team?'请输入队长姓名或学号或队伍名关键词':'请输入姓名或学号关键词'"
        @search="onSearch"
        @cancel="onCancel"
      />
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-show="!team"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in students" :key="item.id">
          <van-cell :border="false" :label="item.snum+' '+item.gender" :title="item.sname" value="<--"/>
          <template slot="right">
            <van-button square type="danger" @click="delStuById(item.id,item.sname)" text="刪除"/>
          </template>
        </van-swipe-cell>

      </van-list>

      <van-collapse @change="teamChange" v-show="team" v-model="activeName" accordion>
        <van-collapse-item :title="'('+(index+1)+') '+item.teamName+' '+item.maxp+'人队 '" :name="item.teamCode"
                           v-for="(item,index) in students" :key="item.id"
        >
          <van-swipe-cell v-for="(item,index) in teamMates" :key="item.id">
            <van-cell :border="false" :label="item.snum+' '+item.gender" value="<--">
              <template #title>
                <span class="custom-title">{{ '(' + (index + 1) + ') ' + item.sname + ' ' }}</span>
                <van-tag v-if="item.leader" type="primary">队长</van-tag>
              </template>
            </van-cell>
            <template slot="right">
              <van-button square type="danger" @click="delStuById(item.id,item.sname,item.leader)" text="刪除"/>
            </template>
          </van-swipe-cell>
        </van-collapse-item>
      </van-collapse>
    </van-pull-refresh>

    <!--    分页-->
    <van-pagination v-show="countStu!=-1&&!team"
                    v-model="currentPage"
                    :total-items="125"
                    :page-count="pageCount"
                    :show-page-size="5"
                    force-ellipses
                    @change="onPageChange"
                    style="bottom: 0;position: fixed; width: 100%;padding-top: 20px"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  NavBar, SwipeCell, Cell, Button, List, PullRefresh, Toast, Dialog,
  Search, Pagination, Sticky, CellGroup, ActionSheet, Divider, Switch, Form, Field, Stepper, Collapse, CollapseItem, tag
} from 'vant';
import {
  GetCampusActivitiesStuById,
  GetCampusActivitiesTeamMates,
  DelCampusActivitiesStuById
} from "../../network/campus_activities"

Vue.use(NavBar);
Vue.use(SwipeCell);
Vue.use(Cell);
Vue.use(Button);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Search);
Vue.use(Pagination);
Vue.use(Sticky);
Vue.use(CellGroup);
Vue.use(ActionSheet);
Vue.use(Divider);
Vue.use(Switch);
Vue.use(Form);
Vue.use(Field);
Vue.use(Stepper);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(tag);
export default {
  name: "CampusActivitiesMember",
  data() {
    return {
      // 页面传过来的数据
      cid: 0,
      team: false,
      title: "",

      students: [],

      teamMates: [],
      // Collapse
      activeName: 0,
      //搜索框
      searchValue: '',

      //刷新列表
      refreshing: false,
      loading: false,
      finished: true,

      //统计多少学生
      countStu: 0,

      //分页
      currentPage: 0,
    }
  },
  activated() {
    const cid = this.$route.query.cid;
    const team = this.$route.query.team;
    const title = this.$route.query.title;
    this.cid = cid;
    this.team = team;
    if(typeof team === 'string' || team instanceof String){
      this.team = team === 'true';
    }
    this.title = title;
    this.getCampusActivitiesStuById("", 1);
  },
  computed: {
    pageCount() {
      if (this.countStu % 10 === 0)
        return this.countStu / 10;
      return parseInt(this.countStu / 10) + 1;
    },
  },
  methods: {
    onSearch(val) {
      this.getCampusActivitiesStuById(this.searchValue);
    },
    onCancel() {
      this.getCampusActivitiesStuById(this.searchValue);
    },
    onPageChange() {
      this.getCampusActivitiesStuById(this.searchValue, this.currentPage);
    },
    getCampusActivitiesStuById(key, page = 1) {
      GetCampusActivitiesStuById(this.cid, key, this.team, page).then(res => {
        this.countStu = res.count;
        this.students = res.info;
      })
    },
    onClickLeft() {
      this.$router.replace("CampusActivities");
    },
    delStuById(id, sname, leader) {
      Dialog.confirm({
        title: '提示',
        message: (leader ? '删除队长，对应的整个队伍将被删除' : ('确定要删除 ' + sname + ' 吗'))
      }).then(() => {
        DelCampusActivitiesStuById(id).then(res => {
            if (res) {
              if (this.team) {
                this.teamMates = this.teamMates.filter(item => item.id != id);
              } else {
                this.students = this.students.filter(item => item.id != id);
                this.countStu = this.countStu - 1;
              }

              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });

    }
    ,
    teamChange(e) {
      GetCampusActivitiesTeamMates(e,this.cid).then(res => {
        this.teamMates = res;
      })
    },
    //refresh
    onLoad() {
      setTimeout(() => {
        this.getCampusActivitiesStuById(this.searchValue, this.currentPage);
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.students = [];
      // 重新加载数据
      this.GetCourseStuListLikeKeyByPage("");
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
    },
    getEtime(etime) {
      return Math.floor(etime / 60) + '小时' + etime % 60 + '分钟'
    },
    parseDate(date) {
      if (date >= 10)
        return date;
      return '0' + date;
    },
  }
}
</script>

<style scoped>

</style>
